export const SEO_FIELDS_SLUG = 'seo-fields'
